<template>
  <div>
    <v-card class="pb-4">
      <v-card-title
        class="subtitle-1 font-weight-bold"
      >{{ $vuetify.lang.t('$vuetify.application.list.title', [getTitle()]) }}
      </v-card-title>
      <v-divider></v-divider>
      <div class="mt-5 mx-5">
        <v-btn :loading="loading.refresh" @click="refreshItems()" class="mr-2 my-2" depressed>
          <v-icon color="primary" left>mdi-refresh</v-icon>
          {{ $vuetify.lang.t('$vuetify.btn.refresh') }}
        </v-btn>
        <v-btn @click="newApp()" class="mr-2 my-2" depressed>
          <v-icon color="primary" left>mdi-application</v-icon>
          {{ $vuetify.lang.t('$vuetify.users.btn.apps.new.title') }}
        </v-btn>
        <v-btn @click="showFilter()" class="mr-2 my-2" depressed>
          <v-icon color="primary" left>mdi-filter-outline</v-icon>
          {{ $vuetify.lang.t('$vuetify.application.btn.filter.title') }}
        </v-btn>
      </div>
    </v-card>
    <v-progress-linear :indeterminate="true" height="2" v-if="loading.list"></v-progress-linear>
    <v-data-iterator
      :footer-props="{
        'items-per-page-options': itemPerPageOptions
      }"
      :items="items"
      :items-per-page="itemPerPage"
      :options.sync="pagination"
      :server-items-length="meta.total"
      :sort-by="sortBy"
      :sort-desc="sortDesc"
    >
      <template v-slot:default="props">
        <v-row>
          <v-col
            :key="item.id"
            cols="12"
            lg="3"
            md="4"
            sm="6"
            v-for="item in props.items"
          >
            <v-hover
              v-slot:default="{ hover }"
            >
              <v-card :elevation="hover ? 24 : 4">
                <v-card-title><h5 :title="item.name ">{{ item.name }}</h5></v-card-title>
                <v-divider></v-divider>
                <v-list dense>
                  <v-list-item>
                    <v-list-item-content class="body-1 font-weight-bold">{{
                      $vuetify.lang.t('$vuetify.application.cols.shortName.title') }} :
                    </v-list-item-content>
                    <v-list-item-content class="align-end body-1">{{ item.shortName }}
                    </v-list-item-content>
                  </v-list-item>
                  <v-list-item>
                    <v-list-item-content class="body-1 font-weight-bold">{{
                      $vuetify.lang.t('$vuetify.application.cols.notificationActive.title') }} :
                    </v-list-item-content>
                    <v-list-item-content class="align-end body-1">
                      <v-tooltip top>
                        <template v-slot:activator="{ on }">
                          <template v-if="item.notificationActive">
                            <v-icon
                              @click="performAction(item, 'notification')"
                              class="pointer"
                              color="teal accent-4"
                              dark
                              v-on="on"
                            >mdi-check-circle-outline
                            </v-icon>
                          </template>
                          <template v-else>
                            <v-icon
                              @click="performAction(item, 'notification')"
                              class="pointer"
                              color="red accent-4"
                              dark
                              v-on="on"
                            >mdi-close-circle-outline
                            </v-icon>
                          </template>
                        </template>
                        <span
                          v-if="item.notificationActive"
                        >{{ $vuetify.lang.t('$vuetify.application.cols.notificationActive.disable.title', [item.name]) }}</span>
                        <span v-else>{{ $vuetify.lang.t('$vuetify.application.cols.notificationActive.enable.title', [item.name]) }}</span>
                      </v-tooltip>
                    </v-list-item-content>
                  </v-list-item>
                  <v-list-item>
                    <v-list-item-content class="body-1 font-weight-bold">{{
                      $vuetify.lang.t('$vuetify.application.cols.notificationEmailActive.title') }} :
                    </v-list-item-content>
                    <v-list-item-content class="align-end body-1">
                      <v-tooltip top>
                        <template v-slot:activator="{ on }">
                          <template v-if="item.notificationEmailActive">
                            <v-icon
                              @click="performAction(item, 'notificationEmail')"
                              class="pointer"
                              color="teal accent-4"
                              dark
                              v-on="on"
                            >mdi-check-circle-outline
                            </v-icon>
                          </template>
                          <template v-else>
                            <v-icon
                              @click="performAction(item, 'notificationEmail')"
                              class="pointer"
                              color="red accent-4"
                              dark
                              v-on="on"
                            >mdi-close-circle-outline
                            </v-icon>
                          </template>
                        </template>
                        <span
                          v-if="item.notificationEmailActive"
                        >{{ $vuetify.lang.t('$vuetify.application.cols.notificationEmailActive.disable.title', [item.name]) }}</span>
                        <span v-else>{{ $vuetify.lang.t('$vuetify.application.cols.notificationEmailActive.enable.title', [item.name]) }}</span>
                      </v-tooltip>
                    </v-list-item-content>
                  </v-list-item>
                  <v-list-item>
                    <v-list-item-content class="body-1 font-weight-bold">{{
                      $vuetify.lang.t('$vuetify.application.cols.active.title') }} :
                    </v-list-item-content>
                    <v-list-item-content class="align-end body-1">
                      <v-tooltip top>
                        <template v-slot:activator="{ on }">
                          <v-icon
                            @click="performAction(item, 'active')"
                            class="pointer"
                            color="teal accent-4"
                            dark
                            v-if="item.active"
                            v-on="on"
                          >mdi-check-circle-outline
                          </v-icon>
                          <v-icon
                            @click="performAction(item, 'active')"
                            class="pointer"
                            color="red accent-4"
                            dark
                            v-else
                            v-on="on"
                          >mdi-close-circle-outline
                          </v-icon>
                        </template>
                        <span
                          v-if="item.active"
                        >{{ $vuetify.lang.t('$vuetify.application.cols.active.disable.title') }}</span>
                        <span
                          v-else>{{ $vuetify.lang.t('$vuetify.application.cols.active.enable.title') }}</span>
                      </v-tooltip>
                    </v-list-item-content>
                  </v-list-item>
                  <v-list-item v-if="$auth.check(['ROLE_ADMIN', 'ROLE_COMMERCIAL', 'ROLE_COMPTA'])">
                    <v-list-item-content class="body-1 font-weight-bold">{{
                      $vuetify.lang.t('$vuetify.application.cols.owner.title') }} :
                    </v-list-item-content>
                    <v-list-item-content class="align-end body-1">{{
                      item.user.username }}
                    </v-list-item-content>
                  </v-list-item>
                </v-list>
                <v-divider></v-divider>
                <v-card-actions>
                  <template>
                    <v-tooltip top>
                      <template v-slot:activator="{ on }">
                        <v-btn @click="editApp(item)" color="primary" icon small text v-on="on">
                          <v-icon>mdi-pencil-outline</v-icon>
                        </v-btn>
                      </template>
                      <span>{{ $vuetify.lang.t('$vuetify.application.btn.edit.title') }}</span>
                    </v-tooltip>
                    <v-tooltip top>
                      <template v-slot:activator="{ on }">
                        <v-btn @click="viewApp(item)" color="primary" icon small text v-on="on">
                          <v-icon>mdi-eye-outline</v-icon>
                        </v-btn>
                      </template>
                      <span>{{ $vuetify.lang.t('$vuetify.application.btn.view.title') }}</span>
                    </v-tooltip>
                    <v-tooltip top>
                      <template v-slot:activator="{ on }">
                        <v-btn
                          @click="$router.push({name: 'payment', query:{applicationId: item.id, applicationName: item.name}})"
                          color="primary" icon
                          small
                          text
                          v-on="on">
                          <v-icon>mdi-cards-outline</v-icon>
                        </v-btn>
                      </template>
                      <span>{{ $vuetify.lang.t('$vuetify.application.btn.payment.tooltip') }}</span>
                    </v-tooltip>
                    <v-tooltip top>
                      <template v-slot:activator="{ on }">
                        <v-btn @click="performAction(item, 'new-secret')" color="primary" icon small text v-on="on">
                          <v-icon>mdi-key-outline</v-icon>
                        </v-btn>
                      </template>
                      <span>{{ $vuetify.lang.t('$vuetify.application.btn.secret.tooltip') }}</span>
                    </v-tooltip>
                    <v-menu>
                      <template v-slot:activator="{ on: menu, attrs }">
                        <v-tooltip top>
                          <template v-slot:activator="{ on: tooltip }">
                            <v-btn
                              color="primary"
                              icon small
                              text
                              v-bind="attrs"
                              v-on="{ ...tooltip, ...menu }"
                            >
                              <v-icon>mdi-laptop-mac</v-icon>
                            </v-btn>
                          </template>
                          <span>{{ $vuetify.lang.t('$vuetify.application.btn.tester.tooltip') }}</span>
                        </v-tooltip>
                      </template>
                      <v-list nav>
                        <v-list-item @click="newTester(item)">
                          <v-list-item-title>{{ $vuetify.lang.t('$vuetify.application.btn.tester.menu.payment') }}
                          </v-list-item-title>
                        </v-list-item>
                        <v-list-item @click="newTester(item, 'transfer')">
                          <v-list-item-title>{{ $vuetify.lang.t('$vuetify.application.btn.tester.menu.transfer') }}
                          </v-list-item-title>
                        </v-list-item>
                      </v-list>
                    </v-menu>
                    <v-tooltip top>
                      <template v-slot:activator="{ on }">
                        <v-btn @click="performAction(item, 'delete')" color="red accent-4" icon small text v-on="on">
                          <v-icon>mdi-delete-forever-outline</v-icon>
                        </v-btn>
                      </template>
                      <span>{{ $vuetify.lang.t('$vuetify.application.btn.delete.tooltip') }}</span>
                    </v-tooltip>
                  </template>
                </v-card-actions>
              </v-card>
            </v-hover>
          </v-col>
        </v-row>
      </template>
      <template v-slot:no-data>
        <v-card class="pb-4 my-5" height="50">
          <v-card-text class="body-1 font-weight-black">{{ $vuetify.lang.t('$vuetify.dataIterator.noResultsText') }}
          </v-card-text>
        </v-card>
      </template>
    </v-data-iterator>
    <status-form :dialog="dialogForm" @getItems="getItems" ref="statusForm"></status-form>
    <app-form :dialog="dialogForm" :form="form" @getItems="getItems" ref="appForm"></app-form>
    <filter-form :dialog="dialogForm" :filter="filter" @performFilter="performFilter" ref="filterForm"></filter-form>
    <detail-form :dialog="dialogForm" :form="form" ref="detailForm"></detail-form>
    <tester-payment-form :dialog="dialogForm" :form="tester.form" ref="testerPaymentForm"></tester-payment-form>
    <tester-transfer-form :dialog="dialogForm" :form="tester.form" ref="testerTransferForm" :fromApplication="true"></tester-transfer-form>
  </div>
</template>

<script>
  import ListMixin from "./../../mixins/Common/List.vue";
  import AppForm from './Form';
  import TesterPaymentForm from '../tester/PaymentForm';
  import TesterTransferForm from '../tester/TransferForm';
  import StatusForm from './StatusForm';
  import DetailForm from './Detail';
  import FilterForm from './Filter';
  import CONSTANTS from '../../helpers/Constants';

  export default {
    mixins: [ListMixin],
    data: () => ({
      urlItems: "/applications",
      sortBy: ['a_id'],
      itemPerPageOptions: [8, 16, 30],
      itemPerPage: 8,
      dialogForm: {
        title: "$vuetify.application.btn.new",
        shows: {
          showApp: false,
          showInfo: false,
          showDetail: false,
          showFilter: false,
          showConfirm: false,
          showPaymentTester: false,
          showTransferTester: false
        },
        saveBtnTitle: "$vuetify.btn.save",
        action: "create"
      },
      form: CONSTANTS.defaultAppForm(),
      filter: {
        user: null,
        name: null,
        shortName: null,
        email: null,
        apiKey: null
      },
      tester: {
        response: {
          transaction_id: null,
          invoice_id: null,
          expired_at: null,
          redirect_url: null,
          status: null,
          type: null,
          operation: null
        },
        form: {
          application: null,
          user: null,
          amount: null,
          notif_url: null,
          return_url: null,
          type: null,
          api_key: null,
          secret: null,
          account_number: null
        }
      }
    }),
    created() {
      this.tester.form.notif_url = process.env.VUE_APP_BASE_NOTIFY_URL;
      this.tester.form.return_url = process.env.VUE_APP_BASE_RETURN_URL + "/payment";
      if (this.$route.query.userId && this.$route.query.username) {
        this.filter.user = this.$route.query.userId;
      }
      this._search = this.buildSearchQuery()
    },
    methods: {
      newApp() {
        this.dialogForm.action = "create";
        this.form = CONSTANTS.defaultAppForm();
        if (!this._.isEmpty(this.$route.query.username)) this.form.user = this.$route.query.userId;
        this.dialogForm.title = this.$vuetify.lang.t("$vuetify.application.btn.new", [this.getTitle()]);
        this.dialogForm.saveBtnTitle = this.$vuetify.lang.t("$vuetify.btn.save");
        this.dialogForm.shows.showApp = true;
      },
      editApp(app) {
        this.dialogForm.action = "edit";
        this.$refs.appForm.setForm(app);
        this.dialogForm.title = this.$vuetify.lang.t("$vuetify.application.edit.title");
        this.dialogForm.saveBtnTitle = this.$vuetify.lang.t("$vuetify.btn.edit");
        this.dialogForm.shows.showApp = true;
      },
      viewApp(app) {
        this.dialogForm.action = "view";
        this.$refs.detailForm.setForm(app);
        this.dialogForm.title = this.$vuetify.lang.t("$vuetify.application.view.title");
        this.dialogForm.saveBtnTitle = this.$vuetify.lang.t("$vuetify.btn.save");
        this.dialogForm.shows.showDetail = true;
      },
      newTester(item, action="payment") {
        this.dialogForm.action = action;
        this.dialogForm.saveBtnTitle = this.$vuetify.lang.t("$vuetify.btn.confirm");
        if (action === "transfer") {
          this.tester.form.application = item;
          this.dialogForm.title = this.$vuetify.lang.t("$vuetify.tester.new.title2", [item.shortName]);
          this.dialogForm.shows.showTransferTester = true;
          this.$refs.testerTransferForm.resetForm();
        } else {
          this.dialogForm.title = this.$vuetify.lang.t("$vuetify.tester.new.title", [item.shortName]);
          this.dialogForm.shows.showPaymentTester = true;
          this.$refs.testerPaymentForm.resetForm();
        }
        this.tester.form.api_key = item.apiKey;
        this.tester.form.secret = item.secret;
        this.tester.form.user = item.user;
      },
      performAction(app, action = "active") {
        this.$refs.statusForm.setForm(app);
        this.dialogForm.shows.showInfo = true;
        this.dialogForm.action = action;
        switch (action) {
          case "active":
            if (!app.active) {
              this.dialogForm.title = this.$vuetify.lang.t("$vuetify.application.cols.active.enable.message");
              this.dialogForm.saveBtnTitle = this.$vuetify.lang.t("$vuetify.btn.save");
            } else {
              this.dialogForm.title = this.$vuetify.lang.t("$vuetify.application.cols.active.disable.message");
              this.dialogForm.saveBtnTitle = this.$vuetify.lang.t("$vuetify.btn.save");
            }
            break;
          case "notification":
            if (!app.notificationActive) {
              this.dialogForm.title = this.$vuetify.lang.t("$vuetify.application.cols.notificationActive.enable.message");
              this.dialogForm.saveBtnTitle = this.$vuetify.lang.t("$vuetify.btn.save");
            } else {
              this.dialogForm.title = this.$vuetify.lang.t("$vuetify.application.cols.notificationActive.disable.message");
              this.dialogForm.saveBtnTitle = this.$vuetify.lang.t("$vuetify.btn.save");
            }
            break;
          case "notificationEmail":
            if (!app.notificationEmailActive) {
              this.dialogForm.title = this.$vuetify.lang.t("$vuetify.application.cols.notificationEmailActive.enable.message");
              this.dialogForm.saveBtnTitle = this.$vuetify.lang.t("$vuetify.btn.save");
            } else {
              this.dialogForm.title = this.$vuetify.lang.t("$vuetify.application.cols.notificationEmailActive.disable.message");
              this.dialogForm.saveBtnTitle = this.$vuetify.lang.t("$vuetify.btn.save");
            }
            break;
          case "new-secret":
            this.dialogForm.title = this.$vuetify.lang.t("$vuetify.application.cols.secret.message");
            this.dialogForm.saveBtnTitle = this.$vuetify.lang.t("$vuetify.btn.save");
            break;
          case "delete":
            this.dialogForm.title = this.$vuetify.lang.t("$vuetify.application.btn.delete.message");
            this.dialogForm.saveBtnTitle = this.$vuetify.lang.t("$vuetify.btn.save");
            break;
        }
      },
      buildSearchQuery() {
        let query = "";
        if (this.filter.user) query = "a_userId::eq::" + this.filter.user;
        if (this.filter.name) {
          if (this._.isEmpty(query)) query = "a_name::iLike::%" + this.filter.name + "%";
          else query += ",a_name::iLike::%" + this.filter.name + "%";
        }
        if (this.filter.shortName) {
          if (this._.isEmpty(query)) query = "a_shortName::iLike::%" + this.filter.shortName + "%";
          else query += ",a_shortName::iLike::%" + this.filter.shortName + "%";
        }
        if (this.filter.email) {
          if (this._.isEmpty(query)) query = "a_email::iLike::%" + this.filter.email + "%";
          else query += ",a_email::iLike::%" + this.filter.email + "%";
        }
        if (this.filter.apiKey) {
          if (this._.isEmpty(query)) query = "a_apiKey::iLike::%" + this.filter.apiKey + "%";
          else query += ",a_apiKey::iLike::%" + this.filter.apiKey + "%";
        }
        if (this._.isEmpty(query)) query = null;
        return query;
      },
      showFilter() {
        this.dialogForm.title = this.$vuetify.lang.t("$vuetify.application.filter.title");
        this.dialogForm.saveBtnTitle = this.$vuetify.lang.t("$vuetify.application.btn.filter.title");
        this.dialogForm.shows.showFilter = true;
      },
      performFilter() {
        this._search = this.buildSearchQuery();
        let self = this;
        this.getItems().then(() => {
          this.$refs.filterForm.closeDialog();
        }).finally(() => {
          self.$refs.filterForm.stopLoadingBtn();
        })
      },
      getTitle() {
        if (!this._.isEmpty(this.$route.query.username)) return this.$route.query.username;
        return "";
      }
    },
    components: {
      AppForm,
      FilterForm,
      DetailForm,
      TesterPaymentForm,
      TesterTransferForm,
      StatusForm
    }
  };
</script>

<style scoped>

</style>
